import { useEffect } from "react";

import { useAppAuth } from "@/hooks/useAppAuth";
import { useAppPathwayBundles } from "@/hooks/useAppPathwayBundles";
import {
  routeBundleGroupsForSession,
  startBackgroundBundlePreload,
} from "@/routes/startBackgroundBundlePreload";

/**
 * Warms route JavaScript after first paint. Navigation then hits the module
 * cache instead of waiting on a chunk.
 */
export function PreloadRouteBundles(): null {
  const { authenticated, clerkLoaded } = useAppAuth();
  const { loadClientPathway, loadSfsPathway, loadReportingPathway } = useAppPathwayBundles();

  useEffect(() => {
    const groups = routeBundleGroupsForSession({
      clerkLoaded,
      authenticated,
      loadClientPathway,
      loadSfsPathway,
      loadReportingPathway,
    });

    return startBackgroundBundlePreload({
      groups,
      prepare: async () => {
        if (!clerkLoaded || !authenticated) {
          return;
        }
        const jobs: Promise<unknown>[] = [];
        if (loadClientPathway) {
          jobs.push(import("./clientPathwayRoutes"));
        }
        if (loadSfsPathway) {
          jobs.push(import("./sfsPathwayRoutes"));
        }
        if (loadReportingPathway) {
          jobs.push(import("./reportingRoutes"));
        }
        await Promise.all(jobs);
      },
    });
  }, [authenticated, clerkLoaded, loadClientPathway, loadReportingPathway, loadSfsPathway]);

  return null;
}
